'use strict';

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

// pas d'accès au panelService à partir de l'observatoire, on créé donc un service spécifique qui reprend les methoes réellement utilisées
ngModule.factory("obsPanelService", function ($modal, $http) {


    return {

        getPanels: function () {
            var urlPrefix = "/rest/panel";
            return $http.get(urlPrefix + "/list").then((result) => {
                return result.data;
            });
        }
    }


});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/utils/obsPanelService.js